import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../card/card";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalSelect from "../form/HorizontalNormalSelect";
import { checklist as checklistAPI } from "../../api";
import { TaskActionItem } from "./TaskActionItem";

export const TaskAction = ({ value, title = "Task List", black = false }) => {
  const [tasks, setTasks] = useState(value);

  useEffect(() => {
    setTasks(value);
  }, [value]);

  return (
    <Card>
      <CardHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>{title}</div>
        </div>
      </CardHeader>
      <CardBody>
        {tasks.length > 0 ? (
          <table
            style={{
              color: black ? "black" : "white",
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: ".5em 1em",
            }}
          >
            <thead>
              <tr>
                <th>No</th>
                <th>Task</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((ts, indexTask) => (
                <TaskActionItem
                  key={indexTask}
                  indexTask={indexTask}
                  task={ts}
                />
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center text-muted py-4">
            <i className="fa fa-list fa-3x mb-3"></i>
            <p>No tasks yet.</p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};
